import { z } from 'zod';

export const Role = z.enum(['owner', 'member', 'installer', 'admin']);
export type Role = z.infer<typeof Role>;

/** Permissions derived from PROMPT.md §6 "Rollen". */
export const Permission = z.enum([
  'site:read',
  'charging:control',
  'site:control',
  'site:members',
  'site:configure',
  'site:diagnose',
  'audit:read',
  'system:admin',
]);
export type Permission = z.infer<typeof Permission>;

const rolePermissions: Record<Role, readonly Permission[]> = {
  member: ['site:read', 'charging:control'],
  owner: ['site:read', 'charging:control', 'site:control', 'site:members', 'audit:read'],
  installer: [
    'site:read',
    'charging:control',
    'site:control',
    'site:members',
    'site:configure',
    'site:diagnose',
    'audit:read',
  ],
  admin: Permission.options,
};

export function hasPermission(role: Role, permission: Permission): boolean {
  return rolePermissions[role].includes(permission);
}

export function permissionsOf(role: Role): readonly Permission[] {
  return rolePermissions[role];
}
